import { IPaymentCompletedResponse } from "../payments.typings";

export const emvState = {
	emvPay: {
		applyStateLoading: {
			errorMessage: "",
			hasError: false,
			loading: false,
			started: false,
			success: false,
		},
		paymentResponse: {} as IPaymentCompletedResponse,
	},
};

const emvPayReducer = () => {
	return {
		postEmvPayStart: (state, { payload }) => {
			return {
				...state,
				emvPay: {
					...state.emvPay,
					applyStateLoading: {
						started: true,
						loading: true,
						success: false,
						hasError: false,
						errorMessage: "",
					},
				},
			};
		},
		postEmvPayComplete: (state, { payload }) => {
			return {
				...state,
				emvPay: {
					...state.emvPay,
					applyStateLoading: {
						...state.emvPay.applyStateLoading,
						started: true,
						loading: false,
						success: true,
					},
					paymentResponse: payload.data.results,
				},
			};
		},
		postEmvPayFail: (state, { payload }) => {
			return {
				...state,
				emvPay: {
					...state.emvPay,
					applyStateLoading: {
						...state.emvPay.applyStateLoading,
						started: true,
						loading: false,
						success: false,
						hasError: true,
						errorMessage: payload,
					},
				},
			};
		},
		resetEmvPaymentState: (state) => {
			return {
				...state,
				emvPay: {
					applyStateLoading: {
						started: false,
						loading: false,
						success: false,
						hasError: false,
						errorMessage: "",
					},
					paymentResponse: {} as IPaymentCompletedResponse,
				},
			};
		},
	};
};
export default emvPayReducer;
